import { createSlice } from '@reduxjs/toolkit';

const storageSlice = createSlice({
    name: 'storage',
    initialState: {
        used: 0,
    },
    reducers: {
        setStorageUsed: (state, action) => {
            state.used = action.payload;
        },
    },
});

export const { setStorageUsed } = storageSlice.actions;

export default storageSlice.reducer;
